import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import WixSDK from 'shared/utils/wix-sdk';
import { VODCSSModules } from 'shared/utils/wix-connect';

import { getAllSettings } from 'shared/selectors/app-settings';
import { getCurrentUserEmail } from 'widget/selectors/current-site-user';
import { isSubscriptionEnabled } from 'shared/ui-selectors/channel/pricing';

import EVENTS from 'shared/constants/events';

import { LinkButton } from 'shared/components/button/button';
import { sides } from 'shared/constants/popout';

import AccountInfoButton from './account-info-button/account-info-button';
import AccountInfoButtonWithTooltip from './account-info-button-with-tooltip/account-button-with-tooltip';

import styles from './account-button.styl';

import translations from 'widget/components/account/translations';


@connect((state, ownProps) => ({
  appSettings: getAllSettings(state),
  userEmail: getCurrentUserEmail(state),
  isSubscriptionEnabled: isSubscriptionEnabled(ownProps.channelData),
}))
@injectIntl
@VODCSSModules(styles)
export default class AccountButton extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
    infoButtonClassName: React.PropTypes.string,

    appSettings: React.PropTypes.object,
    userEmail: React.PropTypes.string,
    intl: intlShape,

    onLoginClick: React.PropTypes.func,
    onLogoutClick: React.PropTypes.func,
    //click on a simple logout button
    onClick: React.PropTypes.func,
    onSubscriptionCancelClick: React.PropTypes.func,
    onSubscribeClick: React.PropTypes.func,
    tooltipSide: React.PropTypes.oneOf(_.values(sides)),

    isSubscriptionEnabled: React.PropTypes.bool,
  };

  componentDidMount() {
    WixSDK.PubSub.subscribe(
      EVENTS.SESSION.LOGOUT_USER,
      this.handleLogoutEvent
    );
    WixSDK.PubSub.subscribe(
      EVENTS.PAYMENT.CANCEL_SUBSCRIPTION,
      this.handleSubscriptionCancelEvent
    );
  }

  componentWillUnmount() {
    this.unsubscribeLogoutEvent();
    this.unsubscribeSubscriptionEvent();
  }

  @autobind
  handleLogoutEvent() {
    this.props.onLogoutClick();
    this.unsubscribeLogoutEvent();
  }

  @autobind
  handleSubscriptionCancelEvent() {
    this.props.onSubscriptionCancelClick();
    this.unsubscribeSubscriptionEvent();
  }

  unsubscribeLogoutEvent() {
    WixSDK.PubSub.unsubscribe(EVENTS.SESSION.LOGOUT_USER, this.handleLogoutEvent);
  }

  unsubscribeSubscriptionEvent() {
    WixSDK.PubSub.unsubscribe(EVENTS.PAYMENT.CANCEL_SUBSCRIPTION, this.handleSubscriptionCancelEvent);
  }

  get formatMessage() {
    return this.props.intl.formatMessage;
  }

  get loginButton() {
    const { className, onLoginClick } = this.props;
    const { formatMessage } = this;

    return (
      <div className={classnames('qa-sign-in', className)}>
        <LinkButton styleName="account-button"
                    onClick={onLoginClick}
                    data-hook="loginButton">
          {formatMessage(translations.signIn)}
        </LinkButton>
      </div>
    );
  }

  get accountButtonWithTooltip() {
    const { formatMessage } = this;
    const { onLogoutClick, infoButtonClassName, userEmail, tooltipSide } = this.props;

    return (
      <AccountInfoButtonWithTooltip className={infoButtonClassName}
                                    logoutLabel={formatMessage(translations.logout)}
                                    tooltipSide={tooltipSide}
                                    userEmail={userEmail}
                                    onLogoutClick={onLogoutClick}
                                    dataHook="infoButtonWithTooltip" />
    );
  }

  get accountButtonSimple() {
    const { onClick, infoButtonClassName } = this.props;

    return (
      <AccountInfoButton className={infoButtonClassName}
                         onClick={onClick} />
    );
  }

  get accountButton() {
    const { isSubscriptionEnabled } = this.props;
    const { accountButtonSimple, accountButtonWithTooltip } = this;
    return isSubscriptionEnabled ? accountButtonSimple : accountButtonWithTooltip;
  }

  render() {
    const { className, userEmail } = this.props;
    const { loginButton, accountButton } = this;

    if (!userEmail) {
      return loginButton;
    }

    return (
      <div className={classnames('qa-account', className)}
           styleName="account-info-button-wrapper">
        {accountButton}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/account/account-button/account-button.js